import { useState, useEffect } from "react";
import "../Modal.css";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import AutoFillForm from "./AutoFillForm";

const ModalEditOrderVenue = ({ isVisible, onClose, orderId, products }) => {
  const [formData, setFormData] = useState({
    VenueName: "",
    VenueCity: "",
    VenueState: "",
    VenuePostalCode: "",
    VenueStreetAddressOne: "",
    VenueNotes: "",
  });

  // Only set initial values when modal opens
  useEffect(() => {
    if (isVisible) {
      setFormData({
        VenueStreetAddressOne: products?.address || "",
        VenueCity: products?.city || "",
        VenueState: products?.VenueState || "",
        VenuePostalCode: products?.VenuePostalCode || "",
        VenueNotes: products?.VenueNotes || "",
      });
    }
  }, [isVisible]); // Removed `products` from dependencies to prevent overwriting user input


  // Handle input change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://server-gs.vercel.app/admin/order-venue-edit/${products._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          title: "Success!",
          text: "Order venue updated successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        })
        onClose(); // Close modal on success
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error("Failed to update order.");
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center z-50">
      <div className="bg-gray-100 rounded-2xl shadow-2xl w-[600px] mx-5 sm:mx-auto overflow-hidden">
        
    
        <div className="flex justify-between items-center py-4 px-6 bg-blue-600">
          <h1 className="text-white text-xl font-semibold font-roboto">
            Update Order Contact
          </h1>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-blue-700 transition-colors duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <AutoFillForm products={products} onClose={onClose}></AutoFillForm>
      </div>
    </div>
  );
};

export default ModalEditOrderVenue;
